import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import { HashRouter } from "react-router-dom"
import { Toaster } from "react-hot-toast"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <React.StrictMode>
        <Toaster />
        <HashRouter>
            <App />
        </HashRouter>
    </React.StrictMode>
)
